import * as actionTypes from '../types/popupAct';

const initialState = {
  error: false,
  errorMessage: '',
  errorTechInfo: '',
  loading: false,
  visible: false,
  title: '',
  type: '',
  idAct: '',
  statusId: '',
  dopPopup: {
    visible: false,
    text: ''
  },
  okRequest: false,
  note: '',
  okNote: false,
  numberAct: '',
  newFormed: false
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.POPUP_ACT_SHOW:
      return {
        ...state,
        error: false,
        visible: true,
        title: payload.title,
        type: payload.type,
        idAct: payload.idAct,
        statusId: payload.statusId,
        okRequest: false,
        numberAct: payload.numberAct
      };

    case actionTypes.POPUP_ACT_CLOSE:
      return {
        ...state,
        error: false,
        visible: false,
        okRequest: false
      };

    case actionTypes.DOP_POPUP_SHOW:
      return {
        ...state,
        dopPopup: {
          ...state.dopPopup,
          visible: true,
          text: payload.text
        }
      };

    case actionTypes.DOP_POPUP_CLOSE:
      return {
        ...state,
        dopPopup: {
          ...state.dopPopup,
          visible: false
        }
      };

    /** формирование документа первый раз */
    case actionTypes.POPUP_ACT_REPORT:
      return {
        ...state,
        loading: true,
        error: false,
        errorMessage: '',
        errorTechInfo: '',
        okRequest: false,
        newFormed: false
      };
    case actionTypes.POPUP_ACT_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        visible: false,
        error: false,
        okRequest: true,
        newFormed: payload.statusId === 1 && payload.docType !== 4 && payload.type !== 'HOLDEN_REPORT'
      };
    case actionTypes.POPUP_ACT_REPORT_FAIL:
      return {
        ...state,
        visible: false,
        loading: false,
        error: true,
        errorMessage: payload.message,
        errorTechInfo: payload.techInfo,
        okRequest: false,
        newFormed: false
      };

    /** Очистка модального окна с ошибкой */
    case actionTypes.POPUP_ACT_ERROR_CLOSE:
      return {
        ...state,
        error: false,
        errorMessage: '',
        errorTechInfo: '',
        okRequest: false
      };

    case actionTypes.POPUP_ACT_GET_NOTE_SUCCESS:
      return {
        ...state,
        note: payload,
        okNote: false
      };
    case actionTypes.POPUP_ACT_ADD_NOTE_SUCCESS:
      return {
        ...state,
        okNote: true
      };

    case actionTypes.SET_NEW_FORMED:
      return {
        ...state,
        newFormed: payload
      };

    default:
      return state;
  }
};

export default reducer;
